export function formatMoney(value, currency = "INR") {
  if (value === null || value === undefined) return "-";

  const numericValue = Number(value);
  if (!Number.isFinite(numericValue)) return "-";

  const normalizedCurrency =
    String(currency || "INR").trim().toUpperCase() || "INR";

  try {
    return new Intl.NumberFormat("en-IN", {
      style: "currency",
      currency: normalizedCurrency,
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(numericValue);
  } catch {
    return `${normalizedCurrency} ${numericValue.toFixed(2)}`;
  }
}

export function formatMessageRate(value, currency = "INR", options = {}) {
  if (value === null || value === undefined) return "-";

  const numericValue = Number(value);
  if (!Number.isFinite(numericValue)) return "-";

  const normalizedCurrency =
    String(currency || "INR").trim().toUpperCase() || "INR";
  const suffix = options.withSuffix === false
    ? ""
    : options.compact
      ? " / msg"
      : " / message";
  const maximumFractionDigits = options.maximumFractionDigits ?? 4;

  try {
    return `${new Intl.NumberFormat("en-IN", {
      style: "currency",
      currency: normalizedCurrency,
      minimumFractionDigits: 2,
      maximumFractionDigits,
    }).format(numericValue)}${suffix}`;
  } catch {
    const amount = options.maximumFractionDigits === undefined
      ? numericValue.toFixed(2)
      : new Intl.NumberFormat("en-IN", {
          minimumFractionDigits: 2,
          maximumFractionDigits,
        }).format(numericValue);
    return `${normalizedCurrency} ${amount}${suffix}`;
  }
}
